import { DocumentTextIcon } from "@heroicons/react/24/outline";
import ClientUtils from "../../utils/ClientUtils";
import withIconSize from "./hoc/withIconSize";
import { InternalIconProps } from "./types/SvgIconProps";

interface Props extends InternalIconProps {
  className?: string;
}

/* 
  Currently the same as the AppDescriptionIcon
*/
const AppDocumentIcon = (props: Props) => {
  const { className, ...rest } = props;

  return (
    <DocumentTextIcon
      {...rest}
      className={ClientUtils.twClassNames("", props.className)}
    />
  );
};
export default withIconSize(AppDocumentIcon);
